import { createContext, useContext, useMemo, useState } from "react";

const initalNavState = {
  selectedNavItem: undefined,
};

export const NavbarContext = createContext({
  navState: initalNavState,
  setNavState: () => undefined,
});
NavbarContext.displayName = "NavbarContext";

export function NavbarProvider(props) {
  const [navState, setNavState] = useState(initalNavState);

  const value = useMemo(
    () => ({
      navState,
      setNavState,
    }),
    [setNavState, navState]
  );

  return <NavbarContext.Provider value={value} {...props} />;
}

export const useNavbarContext = () => {
  const context = useContext(NavbarContext);

  if (!context) {
    throw new Error("useNavbarContext must be used within a AppProvider");
  }

  return context;
}
